<template>
  <div class="home">
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
    >
    <div v-for="item in dataList">
      <div class="content" @click="clickInfo(item.id)">
        <div class="time">{{ item.time }}</div>
        <div class="card_content">
          <div class="card_left">
            <div class="title">{{ item.title }}</div>
            <div class="readNum">阅读 {{ item.readNum }}人 </div>
          </div>
          <div class="card-right">
            <img class="card-img" :src="item.img">
          </div>
        </div>
      </div>
    </div>
    </van-list>
  </div>
</template>

<script>
import { newsList } from '@api/contentNews'

export default {
  name: 'index',
  components: {},
  data () {
    return {
      loading: false,
      finished: false,
      dataList: [],
      pageNum: 0
    }
  },
  created () {
  },
  mounted () {
  },
  methods: {
    // 加载
    onLoad () {
      // 获取列表内容
      this.pageNum++
      // this.loading = true
      newsList({
        pageNum: this.pageNum
      }).then(res => {
        if (res.data.code === 200) {
          this.loading = false
          if (res.data.data && res.data.data.length === 0) {
            this.finished = true
          } else {
            this.dataList = this.dataList.concat(res.data.data)
          }
        } else {
          this.$toastMsg(res.data.msg)
        }
      })
    },
    // 查看详情
    clickInfo (id) {
      const data = {
        url: `${process.env.VUE_APP_BASE_HOST}/contentNewsInfo?id=${id}`,
        title: '邀工资讯'
      }
      this.$bridge.callHandler('newPage', data, response => {
        console.log('response:', response)
      })
    }
  }
}
</script>

<style lang="scss">
@import "../../assets/css/mixin";

.home {
  height: 100%;
  background-color: #F7F8FA;
  .content {
    background-color: #fff;
    border-radius: 5px;
    margin: 12px;
    padding: 12px;
    box-shadow: 0px 0px 5px 1px rgba(0,0,0,0.05);
    .time{
      font-size: 13px;
      color: #999999;
      margin-bottom: 7px;
    }
    .card_content{
      display: flex;
      justify-content: space-between;
    }
    .card_left{
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }
    .title {
      font-size: 16px;
      line-height: 20px;
      font-weight: bold;
      overflow: hidden;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2; //控制行数
      text-overflow: ellipsis;
      margin-top: -2px;
    }
    .readNum{
      font-size: 12px;
      line-height: 12px;
      color: #999999;
    }
    .card-img {
      width: 60px;
      height: 60px;
      border-radius: 5px;
      margin-left: 15px;
    }
  }
}

</style>
